<template>
  <m-geo-box geo-option="radius" :need-next="true" @go="goNext">
    <m-map-radius selectedType="radius" :is-go.sync="isGo" @updateIsGo></m-map-radius>
  </m-geo-box>
</template>

<script>
  import MGeoBox from '@/components/geo/MGeoBox'
  import MMapRadius from '@/components/geo/MMapRadius'

  export default {
    components: {
      MGeoBox,
      MMapRadius
    },
    data () {
      return {
        isGo: false
      }
    },
    methods: {
      goNext () {
        this.isGo = true
      }
    },
    computed: {
    },
    watch: {
    },
    mounted () {
    }
  }
</script>

<style scoped lang="scss">


</style>



// WEBPACK FOOTER //
// src/pages/order/GeoRadius.vue